import React from "react";
import { UserOutlined } from "@ant-design/icons";

const UserCountBadge = ({ count, size = "medium" }) => {
  const sizeStyles = {
    small: {
      fontSize: "12px",
      padding: "4px 12px",
      iconSize: "14px",
      gap: "4px",
    },
    medium: {
      fontSize: "14px",
      padding: "6px 12px",
      iconSize: "14px",
      gap: "6px",
    },
    large: {
      fontSize: "12px",
      padding: "10px 20px",
      iconSize: "22px",
      gap: "8px",
    },
  };

  const currentSize = sizeStyles[size];

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: currentSize.gap,
        backgroundColor: "var(--primary-background-light)",
        color: "var(--primary-background-darker)",
        borderRadius: "24px",
        padding: currentSize.padding,
        fontWeight: 500,
        fontSize: currentSize.fontSize,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <UserOutlined
        style={{
          fontSize: currentSize.iconSize,
          color: "var(--primary-background-darker)",
        }}
      />
      <span>{count.toLocaleString()}</span>
    </div>
  );
};

export default UserCountBadge;
